import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
    campaigns: [
    {
      id: 1,
      title: 'Tipey Joa / Native Warriors',
      image: 'tipeyjoa-300.png',
      imageUrl: 'https://venmo.com/u/tipeyjoa',
      description: "Tipey Joa's mission is to promote and support social justice, health, education, and cultural/language preservation initiatives in underserved indigenous communities, regardless of the physical and political borders that separate us.",
      organizers: [{id: 1, name: 'Martha Rodriguez (Kumeyaay, San Jose de la Zorra)', url: 'http://kumeyaaycommunitycollege.com/teachers/martha-rodriguez/'}],
      donateMethods: [
      {type: 'Venmo', url: 'https://venmo.com/u/tipeyjoa'}
      ],
      followMethods: [
      {type: 'Facebook', url: 'https://www.facebook.com/Tipey-Joa-Native-Warriors-103318151456227/'},
      ]
    }
    ]
  }
});

export default app;
